<xemex-authorization-container>
  <div class="flex flex-col items-center gap-4 text-center">
    <div
      class="flex items-center justify-center w-16 h-16 rounded-full bg-status-error text-text-error"
    >
      <mat-icon>error_outline</mat-icon>
    </div>

    <h1 class="text-2xl font-bold">{{ 'linkExpired.title' | translate }}</h1>
    <p class="text-sm text-neutral">{{ 'linkExpired.desc' | translate }}</p>

    <xemex-filled-button class="w-full" [fullWidth]="true" (click)="requestNewLink()">
      {{ 'linkExpired.btnRequestNewLink' | translate }}
    </xemex-filled-button>

    <xemex-text-button (click)="backToLogin()">
      {{ 'general.btnBackToLogin' | translate }}
    </xemex-text-button>
  </div>
</xemex-authorization-container>
